import { Component } from '@angular/core';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { ExportImportService } from './exportimport.service';
import { ConfirmService } from '../shared/confirm/confirm.service';
import { AppService } from '../app.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Globals } from '../globals';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { AuthenticationService } from '../auth';

@Component({
    selector: 'exportimport-comp',
    providers: [ExportImportService, ConfirmService, AppService, AuthenticationService], 
    templateUrl: './exportimport.component.html',  
    styleUrls: ['./exportimport.component.css']  
})

export class ExportImportComponent {

    selectedFiles: FileList;
    currentFileUpload: File;
    progress: { percentage: number } = { percentage: 0 };
    error: String;
    duplicates: Boolean;
    modalChoices: any;
    choiceModalForm: FormGroup;

    private importedDataObject = {
        ssn: String,
        occurrence: String,
        employerCode: String,
        referenceNumber: String,
        sapoDate: String,
        uuid: String,
        currentRks: String,
        exists: Boolean
    }

    private importedDataList: any = [];
  
    private activeComponent: boolean;
    private dataRows: any;
    private dataImported = false;
    private dataHasError = false;
    private personsRequireChoice: any;

    constructor(
        private service: ExportImportService,          
        private confirmService: ConfirmService,
        private ngxSmartModalService: NgxSmartModalService,
        private appService: AppService,
        private globals: Globals,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated();
            this.activeComponent = appService.isComponentActive('exportimport');
            this.setDefault();
        }

    setDefault() {
        this.choiceModalForm = new FormGroup({
            selectedChoice: new FormControl()
        });
        this.importedDataList = [];
        this.dataHasError = false;
        this.progress.percentage = 0;
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    upload() {
        this.setDefault();
        this.currentFileUpload = this.selectedFiles.item(0)        
        this.service.pushFileToStorage(this.currentFileUpload).subscribe(event => {
            if (event.type === HttpEventType.UploadProgress) {
                this.progress.percentage = Math.round(100 * event.loaded / event.total);
            } else if (event instanceof HttpResponse) {
                this.service.getXml(this.currentFileUpload).subscribe(
                    data => this.setXmlData(data),
                    error =>  this.setError()
                );           
            }
        })
     
        this.selectedFiles = undefined
    }

    setError() {
        this.dataHasError = true;
        this.ngxSmartModalService.setModalData("", 'errorModal', true);
        this.ngxSmartModalService.getModal('errorModal').open();
        this.dataImported = false;
        this.selectedFiles = undefined;
        this.progress.percentage = 0;

        this.service.deleteFile(this.currentFileUpload).subscribe();
        this.currentFileUpload = undefined;
    }

     setXmlData(data) {
        this.dataRows = data;

        if (this.dataRows.length < 1) {
            this.setError();
        } else {
            for(let i = 0; i < this.dataRows.length; i++) {
                this.importedDataObject = {
                    ssn: this.dataRows[i].ssn,
                    occurrence: this.dataRows[i].occurrence,
                    uuid: this.dataRows[i].uuid,
                    sapoDate: this.dataRows[i].sapoDate,
                    employerCode:this.dataRows[i].employerCode,
                    referenceNumber: this.dataRows[i].referenceNumber,
                    currentRks: this.dataRows[i].currentRks,
                    exists: this.dataRows[i].exists
                };
                if(this.importedDataObject.currentRks != null && this.importedDataObject.currentRks.length > 1) {
                    this.personsRequireChoice =+ 1;
                };
                this.importedDataList.push(this.importedDataObject);
            }
            this.dataImported = true;
        }
    }

    updateEntitiesModal() {
        let updateData = {data: [], size: 0}
        for(let i=0; i < this.importedDataList.length; i++) {
            if(this.importedDataList[i].currentRks != null && this.importedDataList[i].currentRks.length > 0) {
                updateData.data.push(this.importedDataList[i]);
                updateData.size++;
            }
        }
        this.ngxSmartModalService.setModalData(updateData, 'confirmModal', true);
        this.ngxSmartModalService.getModal('confirmModal').open();
    }

    updateEntities(updateData) {
        this.service.updateEntities(updateData)
        .subscribe(
            data => this.showUpdateStatus(data),
            error => console.log(error)
        );
    }

    showUpdateStatus(data){
        if(data > 0){
            this.ngxSmartModalService.setModalData(data, 'statusModal', true);
            this.ngxSmartModalService.getModal('statusModal').open();
        }
    }

    redirect(){
        this.dataImported = false;
        this.currentFileUpload = null;
    }

    showChoiceModal(choices, ssn) {
        this.modalChoices = null;
        this.modalChoices = choices;
        this.ngxSmartModalService.setModalData(ssn, 'choiceModal', true);
        this.ngxSmartModalService.getModal('choiceModal').open();
    }

    setSelected(choice, ssn) {
        for(let i=0; i < this.importedDataList.length; i++) {
            if(this.importedDataList[i].ssn === ssn) {
                for(let n=0;  n < this.importedDataList[i].currentRks.length; n++) {
                    if(this.importedDataList[i].currentRks[n].rkId != choice) {
                        this.importedDataList[i].currentRks.splice(n, 1);
                    }
                }
            }
        }
        this.personsRequireChoice =- 1;
    }
    
}